import type React from 'react';
import { useId } from 'react';

import { FieldSet, Label, LabeledControl, Legend, Radio } from '@zillow/constellation-10';

import type { Section } from '../../models';
import { FEE_PAYMENT_TIME } from '../../constants/stringConstants';
import { getStartDayOfTheLeaseLabel } from '../../constants/functionConstants';

type Props = {
  label: string;
  firstChecked: boolean;
  secondChecked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  section: Section;
  firstField?: string;
  secondField?: string;
};

export default function FeePaymentTime({
  label,
  firstChecked,
  secondChecked,
  onChange,
  section,
  firstField,
  secondField,
}: Props) {
  const radioGroupName = useId();
  const firstFieldDisabled = firstField ? section.isFieldDisabled(firstField) : false;
  const secondFieldDisabled = secondField ? section.isFieldDisabled(secondField) : false;

  return (
    <FieldSet legend={<Legend>{label}</Legend>} disabled={firstFieldDisabled && secondFieldDisabled} required>
      <LabeledControl
        label={<Label>Upon signing the lease</Label>}
        control={
          <Radio
            name={radioGroupName}
            value={FEE_PAYMENT_TIME.FIRST_PAY_ON_SIGN}
            checked={firstChecked}
            onChange={onChange}
          />
        }
        disabled={firstFieldDisabled}
      />
      <LabeledControl
        label={<Label>{getStartDayOfTheLeaseLabel(section)}</Label>}
        control={
          <Radio
            name={radioGroupName}
            value={FEE_PAYMENT_TIME.FIRST_PAY_ON_LEASE_START}
            checked={secondChecked}
            onChange={onChange}
          />
        }
        disabled={secondFieldDisabled}
      />
    </FieldSet>
  );
}
